import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';
import { Action } from 'redux';

export const LOB_STATE_NAME = "Lob";

export interface LobStateStructure {
  lob: string;
}

/** INITIAL STATE */
const INITIAL_STATE: LobStateStructure = {
  lob: null
};

/** ACTION TYPES */
const SET_LOB = 'SET_LOB';

/** ACTION INTERFACE */
export class LobAction implements Action {
  type: string;
  lob: LINE_OF_BUSINESS_ENUM;
}

/** EFFECTIVE DATE ACTIONS */
export function setLob(lob: LINE_OF_BUSINESS_ENUM) { return { type: SET_LOB, lob }; }

/** REDUCER */
export function Lob(state: LobStateStructure = INITIAL_STATE, action: LobAction) {

  const copiedState: LobStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case SET_LOB:
      copiedState.lob = action.lob;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
